import { ButtonUpdate } from '../../Form/Buttons/ButtonUpdate';
import { FormDelete } from '../../Form/FormDelete';

export const Administrator = (props) => {
    const { entity, datas } = props;
    return (
        <div className="admin-list">
            <div className="title">
                <div>{`ADMIN: ${entity} (${datas.length})`}</div>
            </div>
            <div className="thead">
                <div className="block-rows">
                    <div className="id">id</div>
                    <div className="name">lastname</div>
                    <div className="item">firstname</div>
                </div>
                <div className="block-buttons"></div>
            </div>
            {datas.map((el, i) => {
                return (
                    <div key={`i-${i}`} className="rows">
                        <div className="block-rows">
                            <div className="id">{i + 1}</div>
                            <div className="name">{el.lastname}<span className="id">({el.id})</span></div>
                            <div className="item">{el.firstname}</div>
                        </div>
                        <div className="block-buttons">
                            <ButtonUpdate entity={entity} id={el.id} />
                            <FormDelete entity={entity} id={el.id} />
                        </div>
                    </div>
                )
            })}
        </div>
    )
} 